import { hideLoading, showLoading } from 'react-redux-loading-bar';
import api from '../../utils/api/api';

import {
  SET_AUTH_USER,
  UNSET_AUTH_USER,
} from '../../utils/common/constant';

const ActionType = {
  SET_AUTH_USER,
  UNSET_AUTH_USER,
};

const setAuthUserActionCreator = (authUser) => {
  return {
    type: ActionType.SET_AUTH_USER,
    payload: {
      authUser,
    },
  };
};

const unsetAuthUserActionCreator = () => {
  return {
    type: ActionType.UNSET_AUTH_USER,
    payload: {
      authUser: null,
    },
  };
};

const asyncSetAuthUser = ({ email, password }) => {
  return async (dispatch) => {
    dispatch(showLoading());

    try {
      const token = await api.login({ email, password });
      api.putAccessToken(token);

      const authUser = await api.getUserLogged();
      dispatch(setAuthUserActionCreator(authUser));
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncUnsetAuthUser = () => {
  return (dispatch) => {
    dispatch(showLoading());

    dispatch(unsetAuthUserActionCreator());
    api.putAccessToken('');

    dispatch(hideLoading());
  };
};

export {
  ActionType,
  setAuthUserActionCreator,
  unsetAuthUserActionCreator,
  asyncSetAuthUser,
  asyncUnsetAuthUser,
};
